import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.input`
  ${({ theme, displayState }) => css`
    font-size: ${displayState?.fontSize ? displayState?.fontSize : "16px" };
    font-weight: 600;
    width: ${displayState?.width ?? '150px'}; ;
    line-height: 24px;
    outline: none;
    border: none;
    border-bottom: 1px solid ${theme?.color?.secondary};
    color: ${theme?.color?.secondary};
    background-color: #fff;
  `}
`;


export default Atom({ type: 'input', dataType: 'string', template })